module.exports = __webpack_public_path__ + "img/mgh-kyoto-kawaramachi-jokyoji@2x.1c9976c2.jpg";